import { Box, ListItem, Skeleton, Text } from '@chakra-ui/react';

import { BillingFrequency, billingFrequencySchema } from '~/features/checkout/models/checkout';
import { useCurrency } from '~/features/internationalization/hooks/use-currency';
import { usePricePlans } from '~/features/plans/hooks/use-price-plans';

export function BundlePriceListItem({
  billingFrequency = billingFrequencySchema.enum['4month'],
}: {
  billingFrequency?: BillingFrequency;
} = {}) {
  const { currency } = useCurrency();
  const { data: plans } = usePricePlans(currency);
  const displayPrice = plans?.prices?.[billingFrequency]?.individual?.displayPrice;

  if (billingFrequency === billingFrequencySchema.enum.annually) {
    return (
      <ListItem>
        <Text as='small' fontSize='xs'>
          <Box as='sup'>2</Box>Total price of{' '}
          {displayPrice ?? (
            <Skeleton as='span' display='inline-block' height='0.625rem' mx='2px' verticalAlign='middle' width='20px' />
          )}{' '}
          for an annual subscription.
        </Text>
      </ListItem>
    );
  }

  if (billingFrequency === billingFrequencySchema.enum['4month']) {
    return (
      <ListItem>
        <Text as='small' fontSize='xs'>
          <Box as='sup'>2</Box>Total price of{' '}
          {displayPrice ?? (
            <Skeleton as='span' display='inline-block' height='0.625rem' mx='2px' verticalAlign='middle' width='20px' />
          )}{' '}
          for a 4-month bundle, based on the average time to complete a Nanodegree program.
        </Text>
      </ListItem>
    );
  }

  return null;
}
